import * as React from 'react';
import { useSetState } from 'react-use';
import { useTranslation } from 'react-i18next';
import { Space } from 'ebs-design';
import { Filters } from 'components/molecules';
import { useQueryParams, useQueryUpdate } from 'hooks/useQueryParams';

interface ExportsFilterProps {
  count?: number;
  rightComponents?: React.ReactNode;
}

interface FiltersProps {
  search?: string;
  page?: number;
}

export const ExportsFilter: React.FC<ExportsFilterProps> = ({ count, rightComponents }) => {
  const { t } = useTranslation();
  const params = useQueryParams();
  const { updateQuery } = useQueryUpdate();

  const [filters, setFilters] = useSetState<FiltersProps>(params);

  React.useEffect(() => {
    updateQuery({ ...filters, per_page: params.per_page });
  }, [filters]);

  const handleFilters = (value): void => {
    setFilters({ ...value, page: 1 });
  };

  return (
    <Filters className="mb-0" onChange={handleFilters}>
      <Space justify="start">
        <h3 className="title">{`${t('exports.title')}${count ? ` (${count})` : ''}`}</h3>
        <Filters.Search field="search" value={params.search} placeholder={t('filter.search')} />
      </Space>
      <Space justify="end">{rightComponents}</Space>
    </Filters>
  );
};
